import axios from "axios";

const axiosInstance = axios.create({
 // baseURL: "http://localhost:8081/v1/r2r",
  baseURL: "https://ready2rental.onrender.com/v1/r2r",
  headers: {
    "Content-Type": "application/json",
  },
});

// 🔐 Attach token automatically
axiosInstance.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// 🚨 Global error handling
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.clear();
      window.location.href = "/partner-join";
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
